import { RavenTextField } from "@ravenappdev/raven-ui";
import type { TextFieldProps as MuiTextFieldProps } from "@mui/material/TextField";

export type TextFieldProps = MuiTextFieldProps & { fullWidth?: boolean };

export default function TextField(props: TextFieldProps) {
  return <RavenTextField size="small" fullWidth {...props} />;
}
